//Dependencies
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import queryString from 'query-string'
import { Helmet } from 'react-helmet'
//Components
import SpaLandingReserved from '../LandingReserved/SpaLandingReserved'
import { SpaLayout } from './SpaLayout'
import SpaPayment from '../Payment/SpaPayment'
//Assests
//import lmainSpa from '../../images/spa-banner-1600.jpg'
import '../../css/SpaLandingPage.css'
//Actions
import {
    getReservedServices,
    cancelSelectedService,
    setPayer,
    clearLandingDetails,
    getAllContentFeed,
    selectGuestPayer,
    setQueryInfoFromUrl,
    setServicesDataFromId
} from '../../actions/spaServices.actions'
import { initializeIdleTimeout } from '../../actions/user.actions'
import { handlePayment, handlePayPalPayment } from '../../actions/payment.actions'
import { cancelCartItem } from '../../actions/reservation.actions'
//Constants
import { withRouter } from "react-router";
import { getProcessUrls } from '../../api/apiConstants'

import spaBannerImg from '../../images/spa-banner-1600.jpg';

class SpaLandingPage extends Component {
    constructor(props) {
        super(props)
        //Ref to Scroll
        this.payLabelRef = ''
        this.state = {
            showServicePromise: false,
            toggleTriangularArrow: false,
        }
        this.toggleTriangularArrowClick = this.toggleTriangularArrowClick.bind(this)
        this.openDetailsPage = this.openDetailsPage.bind(this);
        this.handlePayPalPayment = this.handlePayPalPayment.bind(this);
        this.handleCartPayment = this.handleCartPayment.bind(this);
    }

    //Mobile View
    toggleTriangularArrowClick = () => {
        const currentArrowState = this.state.toggleTriangularArrow
        const currentServicePromiseState = this.state.showServicePromise
        this.setState({
            showServicePromise: !currentServicePromiseState,
            toggleTriangularArrow: !currentArrowState,
        })
    }

    componentDidMount() {
        // Url Query Params
        let inputQueryString = window.location.href.split('?')[1]
        inputQueryString = inputQueryString ? inputQueryString.split('#')[0] : false

        // eslint-disable-next-line no-undef
        if (inputQueryString) {
            inputQueryString = inputQueryString.replace(/[#//]/g, '')
            const parsed = queryString.parse(inputQueryString)
            this.props.actions.setQueryInfoFromUrl(parsed)
        }
        //Details from Steiner Cintent feed
        this.props.actions.getContentFeed()

        //Page Title
        document.title = "Welcome to Lotus Spa";
        //if(this.props.services.filter)
        // this.props.actions.resetFilter('All',true);

    }

    componentWillUnmount() {
        //Clear Notifications
        this.props.actions.clearLandingDetails()
    }
    openDetailsPage(spaId) {
        // this.props.history.push('reserve');
        this.props.actions.setServicesDataFromId(spaId, this.props.history);
    }

    handleCartPayment(cardData) {
        window.scrollTo(0, this.payLabelRef.offsetTop + 150)
        this.props.actions.handlePayment(cardData)
    }

    handlePayPalPayment() {
        window.scrollTo(0, this.payLabelRef.offsetTop + 150);
        this.props.actions.handlePayPalPayment()
    }

    render() {
        let {
            reservedServices = {},
            payer,
            PaymentDetails = {},
            isPayLoading = false,
            guestDetails = [],
            notification = false,
            isScreenLoading = false,
            authDetails = {},
            daysToCruise
        } = this.props.services
        let { cart, cartPrice } = this.props.reservations
        let { selectGuestPayer } = this.props.actions
        let hasReservation = reservedServices.length > 0
        let { CreditCard, ShipboardCurrencyCode = 'USD' } = PaymentDetails
        let { appTrigger = 'CP' } = authDetails;
        let bookUrl = getProcessUrls['wwwUrl'];
        let lmainSpa = spaBannerImg; //`${bookUrl}/lotus-spa/static/media/spa-banner-1600.791093cc.jpg`;
        let NODE_ENV = getProcessUrls['NODE_ENV'];
        return (
            <div id="container">
                {/**React hemet to link mastercard library to head section */}
                {CreditCard && (
                    <Helmet>
                        {NODE_ENV !== 'production' ?
                            <script
                                src={`https://mtf.gateway.mastercard.com/form/version/${CreditCard.MCAPIVersion ||
                                    '52'}/merchant/${CreditCard.GatewayMID ||
                                    'TESTHA-TOKEN'}/session.js?debug=true`}
                            ></script> :
                            <script
                                src={`https://na-gateway.mastercard.com/form/version/${CreditCard.MCAPIVersion}/merchant/${CreditCard.GatewayMID}/session.js`}
                            ></script>
                        }
                    </Helmet>
                )}
                <SpaLayout isScreenLoading={isScreenLoading} cart={cart} appTrigger={appTrigger}>
                    <main role="main" className="main-bg spa-content full-width tpl-v4">
                        {/* Lotus Spa Banner Image */}
                        <div className="bg-slideshow-container d-sm-block d-none">
                            <div className="row bg-slideshow-row not-ready">
                                <div className="bg-slideshow width-full">
                                    <div id="small-img" className="bg-slideshow-item">
                                        <picture className="slide-img width-full text-center">
                                            <source
                                                media="(min-width: 960px)"
                                                srcSet={lmainSpa}></source>
                                            <source
                                                media="(min-width: 768px)"
                                                srcSet={lmainSpa}></source>
                                            <img
                                                id="spa-banner-img"
                                                alt="Lotus Spa"
                                                src={lmainSpa}
                                            />
                                        </picture>
                                        <div
                                            id="spa-banner-img-id"
                                            data-alt=""
                                            data-src={lmainSpa}
                                            className="lt-ie9_slide-img"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Lotus Spa Banner Image End */}
                        <article id="content" className="content  cp-spacing">
                            <header className="article-header">
                                <div className="article-title">
                                    <div className="container">
                                        <h1
                                            className={`article-title-h1 font-size-p23`}
                                            data-test-id="lotus-spa-heading">
                                            Welcome to Lotus Spa
                                        </h1>
                                    </div>
                                </div>
                                <div className="text-center browse-button-container">
                                    <Link
                                        style={daysToCruise <= 3 ? { pointerEvents: 'none' } : {}}
                                        role="button"
                                        data-test-id="browse-button"
                                        aria-label="Browse Spa Services"
                                        className={`button primary-btn gotham-xn-medium ${daysToCruise <= 3 ? 'disabled' : ''}`}
                                        to="/spaservices">
                                        Browse Spa Services
                                    </Link>
                                </div>
                                {daysToCruise <= 3 &&
                                    <div className='three-days-warning red text-center age-warning-text'>
                                        <span>
                                            <svg role="img" focusable="false" aria-label="Alert" class="svg-icon svg-icon-warning">
                                                <use xlinkHref="#icon-warning"></use>
                                            </svg>
                                        </span>
                                        Within 3 days, spa reservations must be made onboard.
                                    </div>
                                }
                            </header>
                            <div
                                ref={(ref) => (this.payLabelRef = ref)}
                                className="visuallyhidden"></div>
                            <div className="article-container spa-content-container top-spacing-20 bottom-spacing-15 white-bg col-xs-pad-15-bottom">
                                <div className="container">
                                    <section id="service-promise" >
                                        <div className="row justify-content-md-left">
                                            {/* best spa logo container */}
                                            <div className="col-md-3 align-center best-spa-container pl-md-0">
                                                <div className="accolade no-gutters">
                                                    <svg class="svg-icon navbar-svg-icon" aria-hidden="true"><use xlinkHref="#icon-laurel"></use></svg>
                                                    <svg class="svg-icon navbar-svg-icon" aria-hidden="true"><use xlinkHref="#icon-laurel"></use></svg>
                                                    <div className="laurel-content">
                                                        <div className="font-size-p5 gotham-xn-medium text-center">
                                                            BEST SPA
                                                        </div>
                                                        <div className="font-size-p5 gotham-xn-medium text-center">
                                                            ON A CRUISE SHIP
                                                        </div>
                                                        <div className="gotham-xn-book spa-font-12 spa-component-space text-center">
                                                            SpaFinder Wellness 365
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* service Promise */}
                                            {/* service Promise Mobile*/}
                                            <div className="col-md-9  mobile-service-promise text-center top-spacing-30  d-md-none">
                                                <button
                                                    className="font-size-p0 button-link  gotham-bold servicePromiseAlign"
                                                    onClick={this.toggleTriangularArrowClick}>
                                                    View service promise
                                                    <span
                                                        className={
                                                            !this.state.toggleTriangularArrow
                                                                ? 'arrow-down'
                                                                : 'arrow-up'
                                                        }></span>
                                                </button>
                                                {this.state.showServicePromise ? (
                                                    <div
                                                        id="display-service-promise"
                                                        className="row gotham-xn-book align-left container col-md-7 padding-10">
                                                        <h3
                                                            className="font-size-p5 gotham-xn-medium"
                                                            data-test-id="service-promise">
                                                            Service Promise
                                                        </h3>
                                                        <p className="font-size-p1 gotham-book no-pad-margin spa-component-space">
                                                            We pride ourselves on enriching the
                                                            lives of all our guests with premium
                                                            treatments that nurture wellness on
                                                            every level. If our staff does not meet
                                                            your service expectations during your
                                                            treatment, we will issue a full refund.
                                                        </p>
                                                    </div>
                                                ) : null}
                                            </div>
                                            {/* service Promise */}
                                            <div className="col-md-9 d-none d-md-block">
                                                <h2
                                                    className="gotham-xn-book font-size-p8"
                                                    data-test-id="service-promise">
                                                    Service Promise
                                                </h2>
                                                <p className="gray-333 text-left spa-component-space">
                                                    We pride ourselves on enriching the lives of all
                                                    our guests with premium treatments that nurture
                                                    wellness on every level. If our staff does not
                                                    meet your service expectations during your
                                                    treatment, we will issue a full refund.
                                                </p>
                                            </div>
                                        </div>
                                    </section>
                                    <section id="reservations-payments" className="row bottom-spacing-15">
                                        <div className="headline-bar">
                                            <h3 id='spa-reservations-heading' className="headline-gray-e6-bg font-size-p11" data-test-id="spa-reservation-payment">Spa Reservations & Payment</h3>
                                            <div className="spa-center-align spa-notify-banner pt-0">
                                                {notification && notification.bannerText && (
                                                    <div role='alert'
                                                        className={`${
                                                            notification.type === 'fail'
                                                                ? 'fail-text  notification-text'
                                                                : 'headline-green-638325-bg notification-text'
                                                            } font-size-p9 gotham-xn-medium`}>{`${notification.bannerText}`}</div>
                                                )}
                                            </div>
                                        </div>

                                        <div className="col-xs-pad-15" role="group" aria-labelledby="spa-reservations-heading">
                                            <p className="top-spacing-0">
                                                <span id="spa-reserve-msg">
                                                </span>
                                                We encourage you to arrive 30 minutes before your scheduled treatment to begin your Lotus Spa experience by unwinding in our relaxation area, Thermal Suite*, steam room and/or dry sauna (on select vessels).
                                            </p>
                                            <p className="font-size-m2 bottom-spacing-10 top-spacing-10">
                                                *Thermal Suite - separate fee applies
                                            </p>
                                            {!hasReservation ? (
                                                <div className="gotham-bold top-spacing-30 spa-box">
                                                    You do not have any spa treatments reserved yet.
                                                </div>
                                            ) : (
                                                    <SpaLandingReserved
                                                        daysToCruise={daysToCruise}
                                                        payRef={this.payLabelRef}
                                                        actions={this.props.actions}
                                                        openDetailsPage={this.openDetailsPage}
                                                        services={
                                                            this.props.services
                                                        }></SpaLandingReserved>
                                                )}
                                            {cart.length > 0 && (
                                                <SpaPayment
                                                    ShipboardCurrencyCode={ShipboardCurrencyCode}
                                                    handlePayPalPayment={this.handlePayPalPayment}
                                                    data-test-id="payment-received"
                                                    payRef={this.payLabelRef}
                                                    daysToCruise={daysToCruise}
                                                    cancelCartItem={
                                                        this.props.actions.cancelCartItem
                                                    }
                                                    isPayLoading={isPayLoading}
                                                    cartPrice={cartPrice}
                                                    handlePayment={this.handleCartPayment}
                                                    setPayer={this.props.actions.setPayer}
                                                    cart={cart}
                                                    payer={payer}
                                                    openDetailsPage={this.openDetailsPage}
                                                    selectGuestPayer={selectGuestPayer}
                                                    guestDetails={guestDetails}
                                                    services={this.props.services}></SpaPayment>
                                            )}
                                            {hasReservation && (
                                                <>
                                                    <p><strong>Cancellation Policy:</strong><br /><div class="top-spacing-5">Please provide 24 hours for appointment cancellation, or your onboard account will be charged 50% of the treatment cost.</div></p>
                                                    <p><strong>Spa service charge:</strong><br /><div class="top-spacing-5">A service fee of 18% will be automatically charged at the time of service.</div></p>
                                                </>
                                            )}
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </article>
                    </main>
                </SpaLayout>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        services: state.services,
        reservations: state.reservations,
    }
}

const mapDispatchToProps = (dispatch) => {
    const LandingPageActions = {
        getReservedServices: (url) => dispatch(getReservedServices(url)),
        getContentFeed: () => dispatch(getAllContentFeed()),
        cancelSelectedService: (selectedService) =>
            dispatch(cancelSelectedService(selectedService)),
        setPayer: (payer) => dispatch(setPayer(payer)),
        selectGuestPayer: (payer) => dispatch(selectGuestPayer(payer)),
        handlePayment: (parms) => dispatch(handlePayment(parms)),
        clearLandingDetails: () => dispatch(clearLandingDetails()),
        cancelCartItem: (cartItem, inCart) => dispatch(cancelCartItem(cartItem, inCart)),
        handlePayPalPayment: () => dispatch(handlePayPalPayment()),
        initializeIdleTimeout: () => dispatch(initializeIdleTimeout()),
        setServicesDataFromId: (spaid, history) => dispatch(setServicesDataFromId(spaid, history)),
        setQueryInfoFromUrl: (parsed) => dispatch(setQueryInfoFromUrl(parsed)),
    }
    return {
        actions: LandingPageActions,
    }
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(SpaLandingPage))
